module.exports = __webpack_public_path__ + "static/media/cms-icon-empty-data.944a4422.svg";